/**
 * Plan naming shared by the plugin and the web panel (firm-model spec R20, R22). Plan ids
 * are server data (`plans.id`); these are the words people see and the PostHog
 * `org_plan` person property.
 */

/** The plan badge: Trial / Individual / Team (and Beta for beta orgs). */
export function planLabel(plan: string, isBeta: boolean): string {
  if (isBeta) return "Beta";
  if (plan === "trial") return "Trial";
  if (plan === "team") return "Team";
  return "Individual";
}

/** PostHog `org_plan` (R22): a firm of one on any plan is "individual". */
export function orgPlanKind(plan: string): "individual" | "team" {
  return plan === "team" ? "team" : "individual";
}
